export const EmployeeEN = {
	"employee": {
		"title": {
			"delete": "Are you sure you want to delete?",
			"create": "Create",
			"update": "Update",
			"buttonKeep" : "Keep the page after",
			"buttonGo" : "Go to the list after",
			"receptionFile" : "Update reception file",
			"education" : "Update qualification",
			"experience": "Update experience information" ,
			"family" : "Update family information",
			"communist" : "Update communist information",
			"status" : "Update employee status",
			"salary": "Update salary & allowance",
			"career": "Update job information",
			"concurrently" : "Concurrently",
			"insurance": "Update employee insurance",
			"insuranceRate": "CurrentEmployee insurance rate",
			"disableAccount": "Close the account of this personnel profile",
			"reason" : "Reason for leave",
			"workHistory" : "Work auditing",
			"fine" : "Internal Law",
			"rewardWelfare" : "REWARD/WELFARE",
			"deleteEmployeeStatus" : "Delete employee status",
			"questionDelete" : "Are you sure you want to delete this active status of HR?"
		},
		"message": {
			"receptionFile": "Reception information successfully !",
			"updateEmployeeCommunist" : "Update CurrentEmployee Communication information successfully !",
			"updateEmployeeReceipt" : "Update CurrentEmployee Receipt information successfully !",
			"updateEmployeeEducation" : "Update CurrentEmployee Education information successfully !",
			"updateEmployeeExperience" : "Update CurrentEmployee Experience information successfully !",
			"updateEmployeeFamily" : "Update CurrentEmployee Family information successfully !",
			"updateEmployeeStatus" : "Update employee status information successfully !",
			"emailNotEntered":"Email not entered!"

		}
	},
	"employeesSider": {
		"headingLabel": "Manager employee",
		"listEmployee": "List employees",
		"importEmployee": "Import list employees",
		"exportEmployee": "Export list employees",
		"createEmployee": "Create new employee",
		"updateEmployee": "Update employee",
		"working": "Working",
		"waiting": "Waiting",
		"all" : "All",
		"personnelRecord":"Personnel Record",
		"temporaryLeave":"Temporary Leave",
		"resignation":"Resignation",
		"laborContract":"Labor Contract",
		"laborContractApproval":"Contract Approval",

		"insurance": {
			"label" : "Insurance",
			"estimatedIncreasing":"Estimated Increasing",
			"estimatedDecreases":"Estimated Decreases",
			"paymentHistory":"Payment History",
		},
		"decision": {
			"headingLabel": "Decision",
			"reward": "Reward Decision",
			"appointment": "Decision appoint",
			"transfer": "Decision Transfer",
			"contract": "Decision Contract",
			"salary": "Decision Salary",
			"admission": "Decision Admission",
			"discipline": "Labor discipline decision"
		}
	},
	"employeeForm": {
		"titleSideBar": {
			"basic": "Personnel information",
			"contact": "Contact information",
			"Family": "Family information",
			"education": "Professional information",
			"payment": "Payment information",
			"communist": "Communist party members information",
			"experience": "Work Experience information",
			"imageProfile": "Image profile information",
			"other": "Other Information"


		},
		"titleTab": {
			"employee": "CurrentEmployee information",
			"contract": "Contract"
		},
		"title": {
			"employeeCode": "Personnel ID",
			"timekeepingCode": "Timekeeping Code",
			"docCode": "Profile code",
			"name": "Full name",
			"birthDay": "Date of birth",
			"gender": "Gender",
			"placeOfBirth" : "Place of birth",
			"placeOfOrigin" : "Place of origin",
			"idNumber" : "ID No./Passport",
			"idNumberIssueDate": "Issue date",
			"idNumberIssueBy" : "Place of issue",
			"maritalStatus" : "Marital status",
			"single" : "single",
			"engaged" : "engaged",
			"married" : "married",
			"separated" : "separated",
			"divorced" : "divorced",
			"widow" : "widow",
			"nationality" : "Nationality",
			"ethnic" : "Ethnic",
			"religion" : "Religion",
			"bank" : "Bank name",
			"bankBranch" : "Branch",
			"bankAccountNo" : "Bank account number",
			"bankAccountName" : "Bank account name",
			"taxNumber" : "My tax code",
			"joinDate" : "Joining date",
			"joinMainDate"  : "Official joining date",
			"educationType"  : "Educational level",
			"academicLevel"  : "Highest professional qualification",
			"managerName" : "Direct manager",
			"phone" : "Phone number",
			"email"  : "Email",
			"homeAddressDetail" : "[Permanent Address] House number",
			"homeAddress" : "Permanent Address",
			"currentAddressDetail" : "[Current Address] House number",
			"currentAddress" : "Current Address",
			"relative" : "Relationship",
			"jobTitle" : "Occupation ",
			"true" : "true",
			"false" : "false",
			"isDependent" : "Dependent",
			"dependentFrom" : "From",
			"dependentTo" : "To",
			"dependentTaxNo" : "Tax code",
			"fromDate" : "From",
			"toDate" : "To",
			"fromMonth" : "From",
			"toMonth" : "To",
			"typeId" : "Mode of study",
			"trainingLevel" : "Major",
			"place" : "Place",
			"specialization" : "Specialization",
			"code" : "Code ",
			"status" : "Mode of study",
			"joinAddress" : "Place of Party asmission",
			"joinTransfer": "Place of transfer",
			"companyName": "Company",
			"positionName": "Position",
			"referenceName": "Reference",
			"referencePhone": "Phone number",
			"workDesc": "Description ",
			"male" : "male",
			"female" : "female",
			"other" : "other",
			"note" : "note",
			"fontId" : "Front of ID card",
			"backId" : "Back of ID card",
			"id_Card" : "ID card",
			"avatar" : "Avatar",
			"employeeStatus": "Status"

		},
		"placeHolder": {
			"employeeCode": "Enter CurrentEmployee code",
			"timekeepingCode": "VN.100",
			"docCode": "VPHN.007",
			"name": "Nguyen Van A",
			"birthDay": "dd/mm/yyyy",
			"gender": "Gender",
			"placeOfBirth" : "Place of birth",
			"placeOfOrigin" : "Place of origin",
			"idNumber" : "ID No./Passport",
			"idNumberIssueDate": "dd/mm/yyyy",
			"idNumberIssueBy" : "\nPlace of issue",
			"maritalStatus" : "Marital status",
			"single" : "Nationality",
			"engaged" : "engaged",
			"married" : "married",
			"separated" : "separated",
			"divorced" : "divorced",
			"widow" : "widow",
			"nationality" : "nationality",
			"ethnic" : "ethnic",
			"religion" : "religion",
			"bank" : "Bank name",
			"bankBranch" : "Branch",
			"bankAccountNo" : "Bank account number",
			"bankAccountName" : "Bank account name",
			"taxNumber" : "My tax code",
			"joinDate" : "Joining date",
			"joinMainDate"  : "Official joining date",
			"educationType"  : "Educational level",
			"academicLevel"  : "Highest professional qualification",
			"managerName" : "Direct manager",
			"phone" : "Phone number",
			"email"  : "Email",
			"homeAddressDetail" : "Số 159 Lê lợi ",
			"homeAddress" : "Eg: Hà Cầu, Hà Đông, Hà Nội",
			"currentAddressDetail" : "Eg: P2001 – CT8 – Mỗ Lao",
			"currentAddress" : " Eg: Mỗ Lao, Hà Đông, Hà Nội",
			"relative" : "Relationship",
			"jobTitle" : "Occupation ",
			"true" : "true",
			"false" : "false",
			"isDependent" : "Dependent",
			"dependentFrom" : "From",
			"dependentTo" : "To",
			"dependentTaxNo" : "Tax code",
			"fromDate" : "From",
			"toDate" : "To",
			"fromMonth" : "From",
			"toMonth" : "To",
			"typeId" : "Mode of study",
			"trainingLevel" : "Major",
			"place" : "Place",
			"specialization" : "Specialization",
			"code" : "Code ",
			"status" : "Mode of study",
			"joinAddress" : "Place of Party asmission",
			"joinTransfer": "Place of transfer",
			"companyName": "Company",
			"positionName": "Position",
			"referenceName": "Reference",
			"referencePhone": "Phone number",
			"workDesc": "Description ",
			"male" : "male",
			"female" : "female",
			"other" : "other",
			"note" : "PlaceHolder ..."


		},

		"required" : {
			"employeeCode" : "EmployeeCode field is required !",
			"name" : "Full name field is required !",
			"gender" : "Gender field is required ",
			"maritalStatus" : "Marital Status field is required!",
			"relative" : "Relationship field is required",
			"isDependent" : "Choose dependent",
			"timeKeepingCode" : "TimeKeeping Code is required",
			"docCode" : "Doc  Code field is required!"
		},
		"toolTip" : {
			"employeeCode" : "\nCode structure: {date,'dmy',\"312\"}\nThe code is automatically specified, no editing is allowed",
			"timeKeepingCode" : "Enter the timekeeping code or enter the machine code and timekeeping code in the form MAMAY.MACHAMCONG",
			"docCode" : "Save hard-code file for searching",
			"phone" : "The system will prioritize getting the first phone number when needed.",
			"email" : "The system will send all emails when needed.",
			"homeAddress" : "Enter address, the system will suggest for you",
			"currentAddress" : "Current Address"
		}

	},
	"employeeColumns" : {
		"employeeCode" : "CurrentEmployee Code",
		"timeKeepingCode" : "TimeKeeping Code",
		"name" : "FullName",
		"department" : "Department Name",
		"jobPosition" : "Job Position",
		"jobTitle" : "Job Title",
		"age" : "Age",
		"gender" : "Gender",
		"joinDate" : "Join Date",
		"birthDay":"Birth Day",
		"phone":"Phone number",
		"status":"Status",
	},
	"employeeWelfare": {
		"welfare": "Reward / Welfare",
		"account": "Create account",
		"createAccount": "Would you like to create an account for this employee?",
		"paid": "Paid",
		"includedInSalary": "Included in salary",
		"date": "Date",
		"name": "Welfare's name",
		"money": "Money",
		"type": "Type"
	},
	"tabEmployees": {
		"tab" : {
			"details" :"Details",
			"receptionFile" : "Reception File",
			"receptionProcedure" : "Reception Procedure",
			"contract": "Contract",
			"insurance" : "Insurance",
			"resignation" : "Resignation",
			"attachments" : "Attachment",
			"jobDetail" : "Job details",
			"salaryEmployee" : "Salary and allowance"

		}
	},
	"errorEmployee":{
		"dateBirth" : "Date of birth cannot be greater than current date",
		"phone" : "invalid phone number",
		"fromDate" : "From date cannot be greater than current date",
		"dependNull" : "Depends from date not entered",
		"index" : "In the second line ",
		"toFrom" : "To date should not be less than from date",
		"experienceDate" : "Experience duration cannot be greater than current time",
		"experienceFromTo" : "Experience start time cannot be greater than experienced end time"
	},
	"valueStatus":{
		"waiting": "Waiting",
		"working": "Working",
		"dropTemp": "Drop temp",
		"resignation": "Resignation",
	},
	"deceptionStatus":{
		"waiting1": "Those HSNS that have been received but not yet due to go to work, ",
		"waiting2": "are not allowed to activate the account and do not charge",
		"working1": "Employees who are working normally at the company, ",
		"working2": "always have an account and charge by default",
	}
}
